"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Host = void 0;
var Host;
(function (Host) {
    Host["Editor"] = "editor";
    Host["DataBinding"] = "dataBinding";
    Host["DocumentManagement"] = "documentManagement";
    Host["Thunderbolt"] = "thunderbolt";
})(Host = exports.Host || (exports.Host = {}));
//# sourceMappingURL=registry.types.js.map